const ImageCarouselDots = ({ currentSlide, goToSlide, slideCount, slidesToScroll, testId, render, baseClass, activeClass }) => {

  if (render === null) {
    return render;
  }

  const indexes = [];
  for (let i = 0; i < slideCount; i += slidesToScroll) {
    indexes.push(i);
  }
  return (
    <ul className={baseClass} data-test-id={testId}>
      {
        indexes.map(index => (
          <li key={index}>
            <button
              type="button"
              aria-hidden={true}
              tabIndex={-1}
              className={`${currentSlide === index ? activeClass : ''}`}
              onClick={goToSlide.bind(null, index)}/>
          </li>
        ))
      }
    </ul>
  );
};

export default ImageCarouselDots;
